import $ from 'jquery';
import { directiveSettings } from '../../utils/parse';
import Toggler from '../../utils/toggler';

/**
 * Toggles the visual display of an element on the page.
 * Contains action directives for interacting with a toggler element:
 *  - toggler-open
 *  - toggler-close
 *  - toggler-toggle
 *  - toggler-select
 *
 * @param context
 */
export default function togglerDirective(context=document.body) {
    const $context = $(context);

    $context.find('[sw-toggler]').each(function() {
        const $element = $(this);
        const json = $element.attr('sw-toggler');
        const settings = directiveSettings(json, {
            open: true,
            transition: false,
        }, 'open');

        const toggler = new Toggler(this, settings);

        $element.data('toggler', toggler);
    });

    for (let action of ['open', 'close', 'toggle']) {

        $context.find(`[sw-toggler-${action}]`).each(function() {
            const $element = $(this);
            const json = $element.attr(`sw-toggler-${action}`);
            const settings = directiveSettings(json, {
                target: null,
                on: 'click',
                prevent: true,
            }, 'target');

            $element.on(settings.on, function(e) {
                const $target = settings.target ? $(settings.target) : $element.closest('[sw-toggler]');
                const toggler = $target.data('toggler');

                if (toggler) {
                    toggler[action]();
                }

                if (settings.prevent) {
                    e.preventDefault();
                }
            });
        });
    }

    /**
     * Controls togglers with a <select> field
     * Should be used with the selector directive for best usability
     */
	$context.find('select[sw-toggler-select]').each(function() {
		const $element = $(this);

		const $options = $element.find('option');
		const values = $options.toArray().map((el) => $(el).prop('value'));
		const togglers = values.map(v => $(v).data('toggler'));

		togglers.forEach(function(toggler) {
			if (toggler) {
				const index = togglers.indexOf(toggler);
				const value = values[index];

				toggler.on('open', () => $element.val(value));
			}
		});

		$element.on('change', function() {
			const value = $element.val();
			const index = values.indexOf(value);
			const toggler = togglers[index];

			toggler.open();
		})
	});

    $context.find('[sw-toggler-class]').each(function() {
        const $element = $(this);
        const json = $element.attr(`sw-toggler-class`);
        const settings = directiveSettings(json, {
            target: null,
            openClass: 'is-open',
            closedClass: 'is-closed',
        }, 'target');

        const $target = settings.target ? $(settings.target) : $element.closest('[sw-toggler]');
        const toggler = $target.data('toggler');

        if (toggler) {
            const updateClasses = function() {
                $element.removeClass(toggler.isOpen ? settings.closedClass : settings.openClass);
                $element.addClass(toggler.isOpen ? settings.openClass : settings.closedClass);
            };

            toggler.on('toggle', updateClasses);
            updateClasses();
        }
    });
}



// WEBPACK FOOTER //
// ./source/scripts/directives/action/toggler.js